import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { CheckCheck, LucideIcon } from "lucide-react";

export interface CloseWithReasonsActionProps {
  disabled?: boolean;
  reasons: NonNullable<TellescopeModelFromName<"tickets">["closeReasons"]>;
  onSelectReason: (reason: NonNullable<TellescopeModelFromName<"tickets">["closeReasons"]>[number]) => void;
  Icon?: LucideIcon;
}

export const CloseWithReasonsAction = ({
  disabled,
  reasons,
  onSelectReason,
  Icon = CheckCheck,
}: CloseWithReasonsActionProps) => {
  const { t } = useTranslation("tickets");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          disabled={disabled}
          hoverLabel={t("Mark Complete With Reason")}
        >
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {reasons.map((reason) => {
          return (
            <DropdownMenuItem
              key={reason}
              onClick={() => onSelectReason(reason)}
              className="cursor-pointer"
              data-trackingid="tickets-table-mark-complete-with-reason"
            >
              {reason}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
